import { State } from "infrontjs";

/**
 * Base for the in-app guest states (the four tabs + the detail / sub-pages).
 * They render into the shell's page-content slot and may only be entered when
 * a user (real or anonymous guest) is present.
 *
 * Two hooks drive the shell chrome (read by View.updateChrome after every
 * navigation):
 *   - getActiveTab()    → which bottom-nav tab to light ("home" | "events" |
 *                          "plan" | "chat"), or null for detail/sub-pages.
 *   - showsBottomNav()  → whether the bar is visible at all.
 */
export class InAppState extends State
{
    static ROUTE = null;
    static ID = null;

    canEnter()
    {
        return this.app.user !== null;
    }

    async exit()
    {
        if ( this.app.view.pageContent )
        {
            this.app.view.pageContent.innerHTML = "";
        }
    }

    getRedirectUrl()
    {
        // Not signed in → login. Literal (mirrors LoginState.ROUTE) to avoid a
        // circular import.
        return "/login";
    }

    /** Which tab to highlight; null = none (detail / sub-page). */
    getActiveTab()
    {
        return null;
    }

    /** Whether the bottom tab bar is shown for this screen. */
    showsBottomNav()
    {
        return true;
    }

    /** Render a screen template into the shell's content slot. */
    renderScreen( template, data = {} )
    {
        this.app.view.render( this.app.view.pageContent, template, data );
    }

    /**
     * Is this state still the one on screen?
     *
     * The guard to use after every await in a state: a screen that navigates
     * away while a request is in flight is disposed, and disposal NULLS
     * `this.app` — so the obvious `this.app.stateManager.currentState !== this`
     * throws exactly in the case it was written to handle.
     */
    isActive()
    {
        return !!this.app && this.app.stateManager?.currentState === this;
    }
}
